import { Injectable } from "@angular/core";
import { isLocalStorageSupported } from "@obg/ngx.global";

@Injectable({ providedIn: "root" })
export class TwoFactorAuthLocalStorageService {
	private readonly IS_ENABLED_REMEMBER_DEVICE_LOCAL_STORAGE_KEY = "isEnabledRememberDevice";

	setIsEnabledRememberDevice(isEnabled: boolean | undefined) {
		if (isLocalStorageSupported()) {
			localStorage.setItem(this.IS_ENABLED_REMEMBER_DEVICE_LOCAL_STORAGE_KEY, JSON.stringify(isEnabled ?? false));
		}
	}

	getIsEnabledRememberDevice(): boolean {
		if (isLocalStorageSupported()) {
			const isEnabled = localStorage.getItem(this.IS_ENABLED_REMEMBER_DEVICE_LOCAL_STORAGE_KEY);
			return isEnabled ? JSON.parse(isEnabled) : false;
		}
		return false; // Default value if localStorage is not available
	}
}
